'use server'

import { apiRequest, ApiResponse } from '../request'

export type PackType =
    | 'teleconsultation-minutes'
    | 'fiscal-notes'
    | 'storage-gb'
    | 'ai-credits'
    | 'video-credits'

export interface Pack {
    code: string
    name: string
    type: PackType
    quantity: number
    price: number
}

export async function getPacks(): Promise<ApiResponse<Pack[]>> {
    return apiRequest<Pack[]>('packs', {})
}

export async function getPackByCode(
    code: string
): Promise<ApiResponse<Pack>> {
    return apiRequest<Pack>(`packs/${code}`, {})
}

export async function getCustomPackPreview(
    type: PackType,
    quantity: number
): Promise<ApiResponse<Pack>> {
    return apiRequest<Pack>(`packs/custom/preview?type=${type}&quantity=${quantity}`, {})
}

